module.exports = __webpack_public_path__ + "static/media/ionicons.621bd386.svg";